import React from 'react';
import styled from 'styled-components';

const AdWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem;
  max-width: 100%;
`;

const AdContainer = styled.article`
  display: flex;
  flex-direction: row;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  max-width: 480px;
  width: 100%;
  cursor: pointer;
  font-family: Roboto, Arial, sans-serif;
`;

const AdImage = styled.div`
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  background: ${props => props.imageUrl ? `url(${props.imageUrl}) center/cover no-repeat` : 'linear-gradient(135deg, #f0f0f0, #e0e0e0)'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AdContent = styled.div`
  flex: 1;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const AdHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #70757a;
`;

const AdHeadline = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #1a0dab;
  margin: 2px 0 0 0;
  line-height: 1.2;
`;

const AdDesc = styled.p`
  font-size: 12px;
  color: #3c4043;
  margin: 4px 0 0 0;
  line-height: 1.3;
`;

const AdFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
`;

const AdDomain = styled.span`
  font-size: 10px;
  color: #70757a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AdCTA = styled.button`
  background: #f8f9fa;
  border: 1px solid #dadce0;
  color: #1967d2;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
`;

export default function AdMock({
  headline = 'Sponsored — Product title',
  description = 'Short description for the product or service. Use this to test wrapping and truncation.',
  advertiser = 'Advertiser',
  ctaText = 'Learn more',
  imageUrl = null,
  onClick = () => {},
}) {
  return (
    <AdWrapper>
      <AdContainer onClick={onClick}>
        <AdImage imageUrl={imageUrl}>
          {!imageUrl && (
            <svg width="24" height="24" fill="#ccc" viewBox="0 0 24 24">
              <rect width="24" height="24" rx="4" fill="#e0e0e0" />
            </svg>
          )}
        </AdImage>

        <AdContent>
          <div>
            <AdHeader>
              <span>{advertiser}</span>
              <span>•</span>
              <span>Sponsored</span>
            </AdHeader>
            <AdHeadline>{headline}</AdHeadline>
            <AdDesc>{description}</AdDesc>
          </div>

          <AdFooter>
            <AdDomain>www.{advertiser.toLowerCase().replace(/\s+/g, '')}.com</AdDomain>
            <AdCTA>{ctaText}</AdCTA>
          </AdFooter>
        </AdContent>
      </AdContainer>
    </AdWrapper>
  );
}